/*
         * @ngdoc function
         * @name ePay.Model:Session_ButtonsModel
         * @description
         * Model
         */

export class Session_ButtonsModel {
  save: string | null | undefined;
  pay: string | null | undefined;
  savePay: string | null | undefined;

	constructor(
		save?: string, 
		pay?: string, 
		savePay?: string
	) {
		this.save = save || null;
		this.pay = pay || null;
		this.savePay = savePay || null;
	}
}
